export default {
  name: "MissionExcerpt",
  props: ["mission"],
};
